import { render, staticRenderFns } from "./PATsView.vue?vue&type=template&id=2624734c&"
import script from "./PATsView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PATsView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports